import { render } from "./KnowledgeManagement.vue?vue&type=template&id=56d93f62&scoped=true"
import script from "./KnowledgeManagement.vue?vue&type=script&lang=js"
export * from "./KnowledgeManagement.vue?vue&type=script&lang=js"

import "./KnowledgeManagement.vue?vue&type=style&index=0&id=56d93f62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d93f62"]])

export default __exports__